import { clearIdentity, getAuth, setIdentity, syncIdentityFromSession } from "@/server/authStorage";

export function storeUserData(response) {
  try {
    const userData = {
      id: response.user.id,
      name: response.user.name,
      nickname: response.user.nickname,
      email: response.user.email,
      level: response.user.level,
      user_level_id: response.user.user_level_id,
      profile_photo: response.user.profile_photo
    };
    setIdentity(response.auth, userData, response.permissions);
  } catch (error) {
    clearIdentity();
    throw error;
  }
}

export function syncSessionIdentity(sessionData) {
  const auth = getAuth();
  if (!auth) return false;

  const user = sessionData?.user;
  const permissions = sessionData?.permissions;
  if (!user || typeof user !== "object" || user.id === undefined || !Array.isArray(permissions)) {
    return false;
  }

  return syncIdentityFromSession(user, permissions);
}
